import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col, Input, Label, Modal, ModalBody, ModalHeader, FormGroup, Button, Table, Collapse, CardBody, Card, FormFeedback
} from 'reactstrap';
import { Link } from 'react-router-dom';

import EventComponent from '../../referral/calendarViews/EventComponentt'
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';

import TimePicker from '../../../components/forms/fields/timepicker';

import Isvg from 'react-inlinesvg'
import PatientFilter from '../../../components/patientFilter';
import warrning from '../../../assets/images/warrning.png';
import xIcon from '../../../assets/svg/x.svg';
import InfoModal from '../../../components/infoModal';
import DeleteModal from '../../../components/deleteModal';

import { Calendar, Day, momentLocalizer } from 'react-big-calendar';
import CustomToolbar from '../../referral/calendarViews/CustomToolbar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Tooltip } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";

import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import openChat from '../../../assets/svg/open_chat.svg';

import { Player, Controls } from "@lottiefiles/react-lottie-player";
import arrowDown from '../../../assets/svg/arrow-down2.svg'
import arrowLeft from '../../../assets/svg/arrow-left.svg'

import edit from '../../../assets/svg/edit.svg'
import garabage from '../../../assets/svg/garbage.svg'
import preview from '../../../assets/svg/eye.svg'
import attach from '../../../assets/svg/attach.svg'

import { v4 as uuidv4 } from 'uuid';
import Switch from '../../../components/forms/fields/switch';


const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "rgba(58, 63, 85, 0.9)",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);



import moment from 'moment';
import { faTintSlash } from '@fortawesome/free-solid-svg-icons';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import striptags from 'striptags';
import PatientDocumentInfoTextTooltip from '../../../components/patientDocumentInfoTextTooltip';
import { getLocale } from '../../../helpers/locale';
import LabPortalenComponent from './labportalen';
import LabPortalenAttachmentsModal from './labportalen-attachments-modal';
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


const localizer = momentLocalizer(moment)

function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

/**
* Calendar for doctors
* @author   Stefan Pantic, Aleksandar Dabic, Milan Stanojevic
*/
class TestResults extends Component {
    constructor(props) {
        super(props);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.tableRef = {};
        this.player = React.createRef();
        this.player2 = React.createRef();
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            total: 0,
            loading: true,
            step: 5,
            referrals: [],
            view: typeof window != 'undefined' && window.innerWidth < 768 ? 'day' : 'month',
            searchItemNumber: 0,
            day: new Date(),
            doctorsList: [],
            errorAdditionalDoctors: null,
            visitReasons: [],
            addEventDaybook: false,
            startDate: new Date(),
            openedSections: [],
            modified: 'Not modified'.translate(this.props.lang),
            sections: [],
            isConsentActive: false,
        };



    }
    showPlayer = () => {
        this.setState({
            showPlayer: true,
        });
    };

    hidePlayer = () => {
        this.setState({
            showPlayer: false,
        });
    };
    stopAnimation = () => {
        this.player.current.play();
    };

    get = () => {

        let obj = {
            // doctor: this.props.uData._id,
            patientId: this.props.patient._id,
            // clinic: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            isConsentGrantedAndActive: this.props.isConsentGrantedAndActive

        }
        fetch(API_ENDPOINT + `/users/users/patient/journal-system/has-consent/${this.props.patient._id}/${this.props.selectedGroup}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
        }).then(res => res.json()).then((result) => {
            if (result.success) {
                this.setState({
                    isConsentActive: true
                })
            } else {
                this.setState({
                    isConsentActive: false
                })
            }
        })

        fetch(API_ENDPOINT + '/users/users/patient/test-results/get', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            if (result) {
                if (result.sections) {
                    let sections = result.sections;
                    this.setState({ sections: JSON.parse(JSON.stringify(sections)), sectionsLastState: JSON.parse(JSON.stringify(sections)) })
                } else {
                    this.setState({
                        sections: [],
                    })
                }
                if (result.tsModified) {
                    // let modified = `${moment.unix(result.tsModified).format(this.props.dateFormat)} ${moment.unix(result.tsModified).format("HH:mm:ss")}`
                    let modified = `${this.props.getStringDateTs(result.tsModified, this.props.dateFormat)/*moment.unix(result.tsModified).format(this.props.dateFormat)*/}`
                    this.setState({ modified })

                } else if (result.tsCreated) {
                    // let modified = `${moment.unix(result.tsCreated).format(this.props.dateFormat)} ${moment.unix(result.tsCreated).format("HH:mm:ss")}`
                    let modified = `${this.props.getStringDateTs(result.tsCreated, this.props.dateFormat)/*moment.unix(result.tsCreated).format(this.props.dateFormat)*/}`
                    this.setState({ modified })
                } else {
                    this.setState({
                        modified: 'Not modified'.translate(this.props.lang),
                    })
                }

            }

        })
    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        // if (this.props.patient && this.props.patient.testResult) {
        //     if (this.props.patient.testResult.sections) {
        //         let sections = this.props.patient.testResult.sections;
        //         this.setState({ sections: JSON.parse(JSON.stringify(sections)), sectionsLastState: JSON.parse(JSON.stringify(sections)) })
        //     }
        //     if (this.props.patient.testResult.tsModified) {
        //         // let modified = `${moment.unix(this.props.patient.testResult.tsModified).format(this.props.dateFormat)} ${moment.unix(this.props.patient.testResult.tsModified).format("HH:mm:ss")}`
        //         let modified = `${this.props.getStringDateTs(this.props.patient.testResult.tsModified, `${this.props.dateFormat} HH:mm`)/*moment.unix(this.props.patient.testResult.tsModified).format(this.props.dateFormat)*/}`
        //         this.setState({ modified })
        //     } else if (this.props.patient.testResult.tsCreated) {
        //         // let modified = `${moment.unix(this.props.patient.testResult.tsCreated).format(this.props.dateFormat)} ${moment.unix(this.props.patient.testResult.tsCreated).format("HH:mm:ss")}`
        //         let modified = `${this.props.getStringDateTs(this.props.patient.testResult.tsCreated, `${this.props.dateFormat} HH:mm`)/*moment.unix(this.props.patient.testResult.tsCreated).format(this.props.dateFormat)*/}`
        //         this.setState({ modified })
        //     }
        // }
        this.get();


        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState) {
        // if (this.props.trigger && prevProps?.trigger !== this.props.trigger) {
        //     if (this.props.patient && this.props.patient.testResult) {
        //         if (this.props.patient.testResult.sections) {
        //             let sections = this.props.patient.testResult.sections;
        //             this.setState({ sections: JSON.parse(JSON.stringify(sections)), sectionsLastState: JSON.parse(JSON.stringify(sections)) })
        //         }
        //         if (this.props.patient.testResult.tsModified) {
        //             // let modified = `${moment.unix(this.props.patient.testResult.tsModified).format(this.props.dateFormat)} ${moment.unix(this.props.patient.testResult.tsModified).format("HH:mm:ss")}`
        //             let modified = `${this.props.getStringDateTs(this.props.patient.testResult.tsModified, `${this.props.dateFormat} HH:mm`)/*moment.unix(this.props.patient.testResult.tsModified).format(this.props.dateFormat)*/}`
        //             this.setState({ modified })
        //         } else if (this.props.patient.testResult.tsCreated) {
        //             // let modified = `${moment.unix(this.props.patient.testResult.tsCreated).format(this.props.dateFormat)} ${moment.unix(this.props.patient.testResult.tsCreated).format("HH:mm:ss")}`
        //             let modified = `${this.props.getStringDateTs(this.props.patient.testResult.tsCreated, `${this.props.dateFormat} HH:mm`)/*moment.unix(this.props.patient.testResult.tsCreated).format(this.props.dateFormat)*/}`
        //             this.setState({ modified })
        //         }
        //     }
        // }
        if (prevProps.initialSave != this.props.initialSave && this.props.initialSave) {
            this.updateTestResults();
        }

        if (this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive) {
            this.get();
        }

    }
    componentWillUnmount = () => {
        if (this.fetchWebDocInterval) {
            clearInterval(this.fetchWebDocInterval)
        }
        document.removeEventListener('mousedown', this.handleClickOutside);
    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {

        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }


    toggle = (idx) => {
        if (idx != this.state.openedSection) {
            this.setState({ openedSection: idx })
        } else {
            this.setState({ openedSection: -1 })
        }


    }
    handleClickOutside = (event) => {
        if (this.tableRef && this.state.focusedField) {
            let exists = false;
            for (var key in this.tableRef) {
                if (this.tableRef[key] && this.tableRef[key].contains && this.tableRef[key].contains(event.target)) {
                    exists = true
                }
            }
            if (!exists) {
                this.setState({
                    focusedField: null
                })
            }
        }

    }
    updateTestResults = () => {
        let checkValidation = true;
        let initialSave;
        if (this.props.initialSave && this.props.initialSave !== true) {
            initialSave = { ...this.props.initialSave, changedTab: null }
        }
        let sections = this.state.sections;
        if (sections && sections.length) {
            for (let i = 0; i < sections.length; i++) {
                let section = sections[i];
                if (section && section.items && section.items.length) {
                    for (let j = 0; j < section.items.length; j++) {
                        if (!section.items[j].analysis || !section.items[j].result) {
                            checkValidation = false;
                        }
                    }
                }
            }
        }
        if (!checkValidation) {
            this.setState({ error: 'All required fields must be filled'.translate(this.props.lang) })
            this.props.saveTestResults(false, () => {
                this.props.abortAction()
                this.props.notSaved(false)
                this.props.setStates({ changedTab: null })
            })
        } else {

            let sections = this.state.sections;
            let newSections = [];
            if (sections && sections.length) {
                for (let i = 0; i < sections.length; i++) {
                    if (sections[i].name && sections[i].timestamp) {
                        newSections.push(sections[i])
                    }
                }
            }
            let data = {
                sections: newSections,
                patient: this.props.patient && this.props.patient.socialSecurityNumber,
                group: this.props.selectedGroup,
                clinic: this.props.selectedClinic
            }


            if (data.patient) {
                fetch(API_ENDPOINT + '/users/users/patient/test-results/update', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(res => res.json()).then((result) => {
                    if (result) {
                        this.props.saveTestResults(false, () => {
                            if (initialSave) {
                                this.props.setStates(initialSave)
                            } else {
                                this.props[0].history.push(this.props.changeLinkModal)
                                this.props.abortAction()
                                this.props.notSaved(false)
                            }
                        })
                    }
                })
            }
        }
    }
    deleteSection = (sectionId) => {
        let data = {
            sectionId: sectionId,
            patient: this.props.patient && this.props.patient.socialSecurityNumber,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic
        }
        if (data.patient) {
            fetch(API_ENDPOINT + '/users/users/patient/test-results/delete/section', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result) {

                    if (result.sections) {
                        this.setState({ sectionsLastState: JSON.parse(JSON.stringify(result.sections)) })
                    }
                    if (result.tsModified) {
                        let modified = `${this.props.getStringDateTs(result.tsModified, `${this.props.dateFormat} HH:mm`)/*moment.unix(result.tsModified).format(this.props.dateFormat)*/}`
                        this.setState({ modified })
                    } else if (result.tsCreated) {
                        let modified = `${this.props.getStringDateTs(result.tsCreated, `${this.props.dateFormat} HH:mm`)/*moment.unix(result.tsCreated).format(this.props.dateFormat)*/}`
                        this.setState({ modified })
                    }
                }

            })

        }
    }
    updateSectionHeader = (sectionId, name, timestamp, isSharedWithPatient) => {

        let data = {
            sectionId: sectionId,
            name: name,
            timestamp: timestamp,
            patient: this.props.patient && this.props.patient.socialSecurityNumber,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            isSharedWithPatient,
        }
        if (data.patient) {
            fetch(API_ENDPOINT + '/users/users/patient/test-results/update/section/header', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result) {

                    if (result.sections) {
                        this.setState({ sectionsLastState: JSON.parse(JSON.stringify(result.sections)) })
                    }
                    if (result.tsModified) {
                        let modified = `${this.props.getStringDateTs(result.tsModified, `${this.props.dateFormat} HH:mm`)/*moment.unix(result.tsModified).format(this.props.dateFormat)*/}`
                        this.setState({ modified })
                    } else if (result.tsCreated) {
                        let modified = `${this.props.getStringDateTs(result.tsCreated, `${this.props.dateFormat} HH:mm`)/*moment.unix(result.tsCreated).format(this.props.dateFormat)*/}`
                        this.setState({ modified })
                    }

                }

            })

        }
    }

    updateTableTestResults = (section) => {
        let checkValidation = true;
        if (section && section.items && section.items.length) {
            for (let i = 0; i < section.items.length; i++) {
                if (!section.items[i].analysis || !section.items[i].result) {
                    checkValidation = false;
                }
            }
        }
        if (!checkValidation) {
            this.setState({ error: 'All required fields must be filled'.translate(this.props.lang) })
            return;
        }
        let data = {
            section: section,
            patient: this.props.patient && this.props.patient.socialSecurityNumber,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic
        }

        if (data.patient) {
            this.setState({ showPlayer: true }, () => {
                this.player.current.play();
                fetch(API_ENDPOINT + '/users/users/patient/test-results/update/section', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(res => res.json()).then((result) => {
                    if (result) {
                        this.setState({
                            showPlayer: false,
                            showPlayer2: true,
                        }, () => {
                            setTimeout(() => {
                                this.setState({ showPlayer2: false });
                            }, 1000);
                        })
                        if (result.sections) {
                            this.setState({ sectionsLastState: JSON.parse(JSON.stringify(result.sections)) })
                            // stale state for journal id
                            const hasJournalId = result?.sections?.some(section => section?.journalId);
                            if (hasJournalId) this.get();
                        }
                        if (result.tsModified) {
                            let modified = `${this.props.getStringDateTs(result.tsModified, `${this.props.dateFormat} HH:mm`)/*moment.unix(result.tsModified).format(this.props.dateFormat)*/}`
                            this.setState({ modified })
                        } else if (result.tsCreated) {
                            let modified = `${this.props.getStringDateTs(result.tsCreated, `${this.props.dateFormat} HH:mm`)/*moment.unix(result.tsCreated).format(this.props.dateFormat)*/}`
                            this.setState({ modified })
                        }
                        this.props.notSaved(false)

                    }

                })
            })

        }

    }

    render() {

        function iosDevice() {
            //return true;
            var userAgent = window.navigator.userAgent;
            if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                return true;
            }
            else {
                return false;
            }
        }

        const showLabPortalen = this.props.showLabPortalen;
        const labPortalenLastSyncTs = this.props.clinicGroupSettings?.labPortalenLastSyncTs;
        const labPortalen = showLabPortalen && this.props.clinicGroupSettings?._id && this.props.patient?.socialSecurityNumber ? {
            groupId: this.props.clinicGroupSettings?._id,
            ssn: this.props.patient?.socialSecurityNumber,
        } : null;

        let lpts;
        try {
            if (labPortalenLastSyncTs) {

                const d = new Intl.DateTimeFormat(getLocale(this.props.lang), {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                }).format(new Date(labPortalenLastSyncTs));
                if (d) lpts = d;
            }
        } catch (err) { }

        let showLabPortalenImportButton = false;
        try {
            if (labPortalen && typeof window !== 'undefined') {
                const allowedHosts = ['dev.curoflow.se', 'test.curoflow.se']
                const host = window?.location?.host;
                if (
                    host &&
                    (
                        host.includes('localhost') ||
                        allowedHosts.includes(host)
                    )
                ) showLabPortalenImportButton = true;
            }
        } catch (err) { }

        return (

            <div >
                <Container fluid className="test-results-wrap">
                    <Row>
                        <Col lg='12'>
                            <div >
                                <h6 className="component-header daybook-header">
                                    <div>
                                        <span>{this.props.patient && this.props.patient.userData && this.props.patient.userData.name}</span> <br />
                                        <p>{this.props.patient && this.props.patient.socialSecurityNumber}</p>
                                        {
                                            this.props.patientInfoSettings?.isCustomIdEnabled ?
                                                <p>{this.props.patient?.customId?.[this.props.selectedGroup] ? this.props.patient.customId[this.props.selectedGroup] : ''}</p>
                                                :
                                                null
                                        }
                                    </div>
                                    <label>{'Test results updated'.translate(this.props.lang)}: {this.state.modified}</label>
                                    <div>
                                        {showLabPortalenImportButton && !(this.state.isConsentActive && this.props.isConsentGrantedAndActive) ? <Button
                                            type='button'
                                            style={{ marginRight: 15 }}
                                            color='primary'
                                            onClick={() => {
                                                try {
                                                    const input = document.createElement('input');
                                                    input.type = 'file';
                                                    input.accept = '.xml';
                                                    input.multiple = true;
                                                    input.onchange = async (e) => {
                                                        let files = [];
                                                        if (input.files && Array.from(input.files) && Array.from(input.files).length) {
                                                            for (const file of Array.from(input.files)) {
                                                                const maxSize = 20 * 1024 * 1024; // 20 MB
                                                                if (file && file.type === 'text/xml' && file.size && file.size <= maxSize) files.push(file)
                                                            }
                                                        }

                                                        if (files.length > 0) {
                                                            const formData = new FormData();
                                                            for (let i = 0; i < files.length; i++) {
                                                                formData.append(`file_${i}`, files[i]);
                                                            };

                                                            formData.append('groupId', labPortalen.groupId);
                                                            formData.append('ssn', labPortalen.ssn);

                                                            const response = await fetch(`${API_ENDPOINT}/clinic-groups/lab-portalen-import`, {
                                                                method: "POST",
                                                                headers: {
                                                                    'Authorization': `Bearer ${localStorage?.getItem?.('authToken')}`
                                                                },
                                                                body: formData
                                                            });

                                                            if (response.ok) {
                                                                const result = await response?.json?.();
                                                                if (result.error) {
                                                                    this.setState({ error: result.error });
                                                                } else if (result.testResult) {
                                                                    this.props.setTestResult?.(result.testResult);
                                                                }
                                                            } else {
                                                                this.setState({ error: 'Failed to import LP file(s)' });
                                                            }
                                                        } else {
                                                            this.setState({ error: 'Please select valid XML file(s) lower than 20MB in size' });
                                                        }
                                                    }
                                                    input.click();
                                                } catch (err) { }
                                            }}
                                        >
                                            {'Import LP File(s)'.translate(this.props.lang)}
                                        </Button> : null}
                                        {
                                            !(this.state.isConsentActive && this.props.isConsentGrantedAndActive) ?
                                                <Button color="primary"
                                                    style={{ marginRight: 15 }}
                                                    disabled={(this.props.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.props.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified)}
                                                    onClick={() => {
                                                        if (this.props.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.props.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified) return;

                                                        let sections = this.state.sections;
                                                        let obj = {
                                                            id: uuidv4(),
                                                            name: '',
                                                            isSharedWithPatient: false,
                                                            timestamp: Math.floor(new Date().getTime() / 1000),
                                                            edit: {
                                                                name: '',
                                                                timestamp: Math.floor(new Date().getTime() / 1000),
                                                                isSharedWithPatient: false
                                                            },
                                                            items: [
                                                                {
                                                                    id: uuidv4(),
                                                                    analysis: '',
                                                                    result: '',
                                                                    referentValue: '',
                                                                    comment: '',
                                                                }
                                                            ]
                                                        }

                                                        sections.splice(0, 0, obj);
                                                        this.setState({ sections }, () => {
                                                            this.props.notSaved(true)
                                                        })
                                                    }}>{"Add test result".translate(this.props.lang)}</Button>
                                                :
                                                null
                                        }
                                    </div>
                                </h6>

                                {/* <div className="component-header">
                                    <div className="component-header-info">
                                        <h6>{this.props.patient && this.props.patient.name}</h6>
                                        <p>{this.props.patient && this.props.patient.socialSecurityNumber}</p>
                                    </div>
                                    <div className="update-info">
                                        <h6>{'Test results updated'.translate(this.props.lang)}:</h6>
                                        <p>{this.state.modified}</p>
                                    </div>
                                    <div>
                                        <Button color="primary" onClick={() => {
                                            let sections = this.state.sections;
                                            let obj = {
                                                id: uuidv4(),
                                                name: '',
                                                timestamp: Math.floor(new Date().getTime() / 1000),
                                                edit: {
                                                    name: '',
                                                    timestamp: Math.floor(new Date().getTime() / 1000)
                                                },
                                                items: [
                                                    {
                                                        id: uuidv4(),
                                                        analysis: '',
                                                        result: '',
                                                        referentValue: '',
                                                        comment: '',
                                                    }
                                                ]
                                            }

                                            sections.splice(0, 0, obj);
                                            this.setState({ sections })
                                        }}>{"Add test result".translate(this.props.lang)}</Button>
                                    </div>
                                </div> */}



                            </div>

                        </Col>
                        <Col lg="12">

                            <div className="results-wrap">
                                {labPortalen && !(this.state.isConsentActive && this.props.isConsentGrantedAndActive) ? <div className='lab-portalen-wrap'>
                                    <div>
                                        <Button
                                            color='info'
                                            size='lg'
                                            onClick={async () => {
                                                const response = await fetch(`${API_ENDPOINT}/clinic-groups/lab-portalen-run-cron`, {
                                                    method: "POST",
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'Authorization': `Bearer ${localStorage?.getItem?.('authToken')}`
                                                    },
                                                    body: JSON.stringify(labPortalen)
                                                });

                                                const result = await response?.json?.();
                                                if (result.error) {
                                                    this.setState({ error: result.error });
                                                } else {
                                                    if (result.testResult) this.props.setTestResult?.(result.testResult);
                                                }
                                            }}
                                        >
                                            {'Sync LabPortalen'.translate(this.props.lang)}
                                        </Button>
                                        <PatientDocumentInfoTextTooltip lang={this.props.lang} text={'Results from LabPortalen are automatically synced to Curoflow four times per day. You can manually request sync once in 24h. Sync is done for the entire clinic for test results in the past 3 days.'} className='lab-portalen-pat-docs' />
                                    </div>
                                    {lpts ? <p>
                                        {'Last sync'.translate(this.props.lang)}: {lpts}
                                    </p> : null}
                                </div> : null}
                                <div className='accordion-section-item-wrap accordion-section-item-wrap-header' key='header'>
                                    <div className="accordion-section-item">
                                        <div className="accordion-section-item-block block-1" style={{ width: '20%', textAlign: 'left', justifyContent: 'flex-start' }}>
                                            <h6 style={{ fontWeight: '700' }}>{'Shared with patient'.translate(this.props.lang)} <PatientDocumentInfoTextTooltip lang={this.props.lang} text={'If enabled, patient can view their test results when logged in.'} /></h6>

                                        </div>
                                        <div className="accordion-section-item-block block-1" style={{ width: '20%', textAlign: 'left', justifyContent: 'flex-start' }}>
                                            <h6 style={{ fontWeight: '700' }}>{'Source'.translate(this.props.lang)}</h6>
                                        </div>
                                        <div className="accordion-section-item-block block-1" style={{ width: '20%', textAlign: 'left', justifyContent: 'flex-start' }}>
                                            <h6 style={{ fontWeight: '700' }}>{'Status'.translate(this.props.lang)}</h6>
                                        </div>
                                        <div className="accordion-section-item-block block-1" style={{ width: '20%', textAlign: 'left', justifyContent: 'flex-start' }}>
                                            <h6 style={{ fontWeight: '700' }}>{'Name'.translate(this.props.lang)}</h6>
                                        </div>
                                        <div className="accordion-section-item-block block-2" style={{ width: '20%', textAlign: 'left', justifyContent: 'flex-start' }}>
                                            <h6 style={{ fontWeight: '700' }}>{'Date'.translate(this.props.lang)}</h6>
                                        </div>
                                        <div className="action-buttons" style={{ width: '20%', justifyContent: 'flex-end' }}>
                                            <h6 style={{ fontWeight: '700' }}>{'Actions'.translate(this.props.lang)}</h6>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.sections && this.state.sections.map((item, idx) => {

                                        const source = item.source ?? (item.sembleId || item.externalId ? 'Semble' : 'Curoflow');
                                        const status = item.status ? item.status : '';

                                        let requisitionId = this.props.labPortalenData && this.props.labPortalenData?.dashboardUrl && this.props.labPortalenData?.sessionCode && this.props.labPortalenData?.patientSSN && source?.toLocaleLowerCase?.() === 'labportalen' && item.externalId ? item.externalId : null;

                                        const attachments = item?.attachments && Array.isArray(item.attachments) && item.attachments.length && item.attachments.some(obj => (obj && (obj.type === 'text/html' && obj.html) || (obj.type !== 'text/html' && obj.url)) ? true : false) ? item.attachments.filter(obj => (obj && (obj.type === 'text/html' && obj.html) || (obj.type !== 'text/html' && obj.url)) ? true : false) : null;

                                        return (
                                            <div className='accordion-section-item-wrap' key={item.id || idx}>
                                                <div className="accordion-section-item" onClick={() => {
                                                    this.toggle(idx)
                                                }} style={{ marginBottom: '1rem' }}>
                                                    <div className="accordion-section-item-block block-1" style={{ width: item.edit ? '16%' : '16%', alignSelf: item.edit ? 'center' : undefined }}>
                                                        <h6>
                                                            <Switch
                                                                value={item.edit ? (item.edit.isSharedWithPatient ?? false) : item.isSharedWithPatient ? true : false}
                                                                onChange={e => {
                                                                    if (item.edit) {
                                                                        let sections = this.state.sections;
                                                                        sections[idx].edit.isSharedWithPatient = e.target.checked;
                                                                        this.setState({ sections }, () => {
                                                                            this.props.notSaved(true)
                                                                        })
                                                                    } else {
                                                                        const isSharedWithPatient = e.target.checked;
                                                                        let sections = this.state.sections;
                                                                        sections[idx].isSharedWithPatient = isSharedWithPatient;
                                                                        this.setState({ sections }, () => {
                                                                            this.props.notSaved(true)
                                                                            this.updateSectionHeader(sections[idx].id, sections[idx].name, sections[idx].timestamp, isSharedWithPatient)
                                                                        })
                                                                    }
                                                                }}
                                                                label={item.edit ? 'Share with patient'.translate(this.props.lang) : undefined}
                                                            />
                                                        </h6>
                                                    </div>
                                                    <div className="accordion-section-item-block block-1" style={{ width: item.edit ? '16%' : '16%' }}>
                                                        <h6>
                                                            {item.edit ? ' ' : source}
                                                        </h6>
                                                    </div>
                                                    <div className="accordion-section-item-block block-1" style={{ width: item.edit ? '16%' : '16%' }}>
                                                        <h6>
                                                            {item.edit ? ' ' : status}
                                                        </h6>
                                                    </div>
                                                    <div className="accordion-section-item-block block-1" style={{ width: item.edit ? '16%' : '16%' }}>

                                                        {
                                                            !item.edit ?
                                                                <h6>{item.name}</h6>
                                                                :
                                                                <div>
                                                                    <Input placeholder={'Type of sampling'.translate(this.props.lang)} type="text"
                                                                        value={item.edit.name}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation()
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let sections = this.state.sections;
                                                                            sections[idx].edit.name = e.target.value;
                                                                            if (sections[idx].requiredName) {
                                                                                delete sections[idx].requiredName;
                                                                            }
                                                                            this.setState({ sections }, () => {
                                                                                this.props.notSaved(true)
                                                                            })
                                                                        }} />
                                                                    {
                                                                        item.requiredName ?
                                                                            <FormFeedback>{item.requiredName}</FormFeedback>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                    <div className="accordion-section-item-block block-2" style={{ width: item.edit ? '16%' : '16%' }}>
                                                        {
                                                            !item.edit ?
                                                                <h6>{this.props.getStringDateTs(item.timestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.timestamp).format(this.props.dateFormat)*/}</h6>
                                                                :
                                                                <DatePicker
                                                                    value={this.props.getStringDateTs(item.edit.timestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.edit.timestamp).format(this.props.dateFormat)*/}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation()
                                                                    }}
                                                                    onChange={(e) => {
                                                                        let sections = this.state.sections;
                                                                        if (e) {
                                                                            sections[idx].edit.timestamp = Math.floor(new Date(e).getTime() / 1000);
                                                                        }
                                                                        this.setState({ sections }, () => {
                                                                            this.props.notSaved(true)
                                                                        })
                                                                    }}
                                                                />
                                                        }
                                                    </div>

                                                    <div className="action-buttons" style={{ width: '16%', justifyContent: 'flex-end' }}>
                                                        {
                                                            attachments ? <div onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.setState({
                                                                    labPortalenAttachments: attachments,
                                                                })
                                                            }} className='test-results-tooltip-wrap' style={{ position: 'relative' }}>
                                                                <Isvg src={attach} />
                                                                <div className='test-results-tooltip'>{'Attachments'.translate(this.props.lang)}</div>
                                                            </div> : null
                                                        }
                                                        {
                                                            !item.edit && !item.externalId ?
                                                                <div onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    let sections = this.state.sections;
                                                                    sections[idx].edit = {
                                                                        name: sections[idx].name,
                                                                        timestamp: sections[idx].timestamp,
                                                                        isSharedWithPatient: (sections[idx].isSharedWithPatient) ?? false
                                                                    };
                                                                    this.setState({ sections }, () => {
                                                                        // this.props.notSaved(true)
                                                                    })
                                                                }} className='test-results-tooltip-wrap' style={{ position: 'relative' }}>
                                                                    <Isvg src={edit} />
                                                                    <div className='test-results-tooltip'>{'Edit'.translate(this.props.lang)}</div>

                                                                </div>
                                                                :
                                                                null
                                                        }

                                                        {
                                                            !item.externalId ?
                                                                <div className='test-results-tooltip-wrap' style={{ position: 'relative' }} onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    this.setState({ deleteSectionItem: idx + 1 })
                                                                }}>
                                                                    <Isvg src={garabage} />
                                                                    <div className='test-results-tooltip'>{'Delete'.translate(this.props.lang)}</div>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            item.edit ?
                                                                <Button color='primary' onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    let sections = this.state.sections;
                                                                    if (!sections[idx].edit.name) {
                                                                        sections[idx].requiredName = 'Required'.translate(this.props.lang)
                                                                        this.setState({ sections }, () => {
                                                                        })
                                                                    } else {
                                                                        sections[idx].name = sections[idx].edit.name;
                                                                        sections[idx].timestamp = sections[idx].edit.timestamp;
                                                                        sections[idx].isSharedWithPatient = (sections[idx].edit.isSharedWithPatient) ?? false
                                                                        if (sections[idx].edit) {
                                                                            delete sections[idx].edit;
                                                                        }
                                                                        this.setState({ sections, openedSection: idx }, () => {
                                                                            this.updateSectionHeader(sections[idx].id, sections[idx].name, sections[idx].timestamp, sections[idx].isSharedWithPatient)
                                                                        })

                                                                    }


                                                                }}>{'Save'.translate(this.props.lang)}</Button>
                                                                :
                                                                null
                                                        }
                                                        <div>
                                                            {
                                                                this.state.openedSection == idx && item.name && item.timestamp && !item.edit ?
                                                                    <Isvg src={arrowDown} />
                                                                    :
                                                                    <Isvg src={arrowLeft} />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="accordion-card">
                                                    <Collapse isOpen={this.state.openedSection == idx && item.name && item.timestamp && !item.edit ? true : false} className="no-border">
                                                        <Card >
                                                            <CardBody className='accordion-body-wrap test-result-table-container'>
                                                                {/* {item.content} */}
                                                                <table id={item.id} className='accordion-table-wrap'>
                                                                    <tr>
                                                                        <th>{'Analysis'.translate(this.props.lang)}</th>
                                                                        <th>{'Result'.translate(this.props.lang)}</th>
                                                                        <th>{'Referent value'.translate(this.props.lang)}</th>
                                                                        <th>{'Comment'.translate(this.props.lang)}</th>

                                                                    </tr>
                                                                    {
                                                                        item.items && item.items.map((element, eidx) => {
                                                                            return (
                                                                                <tr ref={node => {
                                                                                    if (!this.tableRef) {
                                                                                        this.tableRef = {};
                                                                                    }
                                                                                    if (element.id) {
                                                                                        this.tableRef[element.id] = node;
                                                                                    }

                                                                                }}>
                                                                                    <td onClick={() => {
                                                                                        if (item.externalId) return;
                                                                                        this.setState({ focusedField: `${element.id}-analysis` }, () => {
                                                                                            if (typeof window != 'undefined') {
                                                                                                document.getElementById(`${element.id}-analysis`).focus()
                                                                                            }
                                                                                        })
                                                                                    }}
                                                                                        className={!element.analysis ? 'required-td' : ''}
                                                                                    >
                                                                                        {
                                                                                            this.state.focusedField == `${element.id}-analysis` ?
                                                                                                <Input id={`${element.id}-analysis`} type='text' className={!element.analysis ? 'required-input' : ''} value={element.analysis} onChange={(e) => {
                                                                                                    let sections = this.state.sections;
                                                                                                    if (sections[idx] && sections[idx].items && sections[idx].items[eidx]) {
                                                                                                        sections[idx].items[eidx].analysis = e.target.value;
                                                                                                        this.setState({ sections }, () => {
                                                                                                            this.props.notSaved(true)
                                                                                                        })
                                                                                                    }
                                                                                                }} />
                                                                                                :
                                                                                                <span>{element.analysis}</span>
                                                                                        }
                                                                                    </td>
                                                                                    <td onClick={() => {
                                                                                        if (item.externalId) return;
                                                                                        this.setState({ focusedField: `${element.id}-result` }, () => {
                                                                                            if (typeof window != 'undefined') {
                                                                                                document.getElementById(`${element.id}-result`).focus()
                                                                                            }
                                                                                        })
                                                                                    }}
                                                                                        className={!element.result ? 'required-td' : ''}
                                                                                    >
                                                                                        {
                                                                                            this.state.focusedField == `${element.id}-result` ?
                                                                                                <Input id={`${element.id}-result`} className={!element.result ? 'required-input' : ''} type='text' value={element.result} onChange={(e) => {
                                                                                                    let sections = this.state.sections;
                                                                                                    if (sections[idx] && sections[idx].items && sections[idx].items[eidx]) {
                                                                                                        sections[idx].items[eidx].result = e.target.value;
                                                                                                        this.setState({ sections }, () => {
                                                                                                            this.props.notSaved(true)
                                                                                                        })
                                                                                                    }
                                                                                                }} />
                                                                                                :
                                                                                                <span >{element.result}</span>
                                                                                        }
                                                                                    </td>
                                                                                    <td onClick={() => {
                                                                                        if (item.externalId) return;
                                                                                        this.setState({ focusedField: `${element.id}-referentValue` }, () => {
                                                                                            if (typeof window != 'undefined') {
                                                                                                document.getElementById(`${element.id}-referentValue`).focus()
                                                                                            }
                                                                                        })
                                                                                    }}>
                                                                                        {
                                                                                            this.state.focusedField == `${element.id}-referentValue` ?
                                                                                                <Input id={`${element.id}-referentValue`} type='text' value={element.referentValue} onChange={(e) => {
                                                                                                    let sections = this.state.sections;
                                                                                                    if (sections[idx] && sections[idx].items && sections[idx].items[eidx]) {
                                                                                                        sections[idx].items[eidx].referentValue = e.target.value;
                                                                                                        this.setState({ sections }, () => {
                                                                                                            this.props.notSaved(true)
                                                                                                        })
                                                                                                    }
                                                                                                }} />
                                                                                                :
                                                                                                <span>{element.referentValue}</span>
                                                                                        }
                                                                                    </td>
                                                                                    <td onClick={() => {
                                                                                        // if (item.externalId) return;
                                                                                        this.setState({ focusedField: `${element.id}-comment` }, () => {
                                                                                            if (typeof window != 'undefined') {
                                                                                                document.getElementById(`${element.id}-comment`).focus()
                                                                                            }
                                                                                        })
                                                                                    }}>
                                                                                        {
                                                                                            this.state.focusedField == `${element.id}-comment` ?
                                                                                                <Input disabled={item.source === 'Journal' ? true : false} id={`${element.id}-comment`} type='text' value={element.comment} onChange={(e) => {
                                                                                                    let sections = this.state.sections;
                                                                                                    if (sections[idx] && sections[idx].items && sections[idx].items[eidx]) {
                                                                                                        sections[idx].items[eidx].comment = e.target.value;
                                                                                                        this.setState({ sections }, () => {
                                                                                                            this.props.notSaved(true)
                                                                                                        })
                                                                                                    }
                                                                                                }} />
                                                                                                :
                                                                                                <span>{element.comment}</span>
                                                                                        }
                                                                                    </td>

                                                                                    {item.externalId ? null :
                                                                                        iosDevice() ?
                                                                                            <td className='test-results-delete-row iphone-row' onClick={() => {
                                                                                                let sections = this.state.sections;
                                                                                                if (sections && sections[idx] && sections[idx].items && sections[idx].items[eidx]) {
                                                                                                    sections[idx].items.splice(eidx, 1)
                                                                                                }
                                                                                                this.setState({ sections }, () => {
                                                                                                    this.props.notSaved(true)
                                                                                                })
                                                                                            }}>
                                                                                                <Isvg src={garabage} />

                                                                                            </td>
                                                                                            :
                                                                                            <div className='test-results-delete-row test-results-tooltip-wrap' onClick={() => {
                                                                                                let sections = this.state.sections;
                                                                                                if (sections && sections[idx] && sections[idx].items && sections[idx].items[eidx]) {
                                                                                                    sections[idx].items.splice(eidx, 1)
                                                                                                }
                                                                                                this.setState({ sections }, () => {
                                                                                                    this.props.notSaved(true)
                                                                                                })
                                                                                            }}>
                                                                                                <Isvg src={garabage} />
                                                                                                <div className='test-results-tooltip'>{'Delete'.translate(this.props.lang)}</div>

                                                                                            </div>
                                                                                    }


                                                                                </tr>


                                                                            )

                                                                        })

                                                                    }
                                                                </table>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                    {item.externalId ? null : <Button color='primary' onClick={() => {
                                                                        let sections = this.state.sections;
                                                                        if (sections && sections[idx] && sections[idx].items) {
                                                                            sections[idx].items.push({
                                                                                id: uuidv4(),
                                                                                analysis: '',
                                                                                result: '',
                                                                                referentValue: '',
                                                                                comment: ''
                                                                            })
                                                                            this.setState({ sections }, () => {
                                                                                this.props.notSaved(true)
                                                                            })
                                                                        }
                                                                    }}>{'Add new line'.translate(this.props.lang)}</Button>}
                                                                    {
                                                                        item.source === 'Journal' ? null :
                                                                            <Button color='primary' onClick={() => {
                                                                                let sections = this.state.sections;
                                                                                if (sections && sections[idx]) {
                                                                                    this.updateTableTestResults(sections[idx])
                                                                                }

                                                                            }}>
                                                                                {
                                                                                    this.state.showPlayer ? (
                                                                                        <Player
                                                                                            onEvent={(event) => {
                                                                                                if (event === "load") this.stopAnimation();
                                                                                            }}
                                                                                            onStateChange={this.toggleVisibility}
                                                                                            ref={this.player} // set the ref to your class instance
                                                                                            autoplay={true}
                                                                                            loop={true}
                                                                                            controls={true}
                                                                                            src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                                                            style={{ height: "30px", width: "30px" }}
                                                                                        ></Player>

                                                                                    ) : this.state.showPlayer2 ? (
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }}><Player
                                                                                            onStateChange={this.toggleVisibility}
                                                                                            ref={this.player2} // set the ref to your class instance
                                                                                            autoplay={true}
                                                                                            loop={true}
                                                                                            controls={true}
                                                                                            src="https://assets10.lottiefiles.com/packages/lf20_CxyxLk.json"
                                                                                            style={{ height: "30px", width: "30px" }}
                                                                                        ></Player>
                                                                                            {'Saved'.translate(this.props.lang)}
                                                                                        </div>
                                                                                    ) : (
                                                                                        "Save".translate(this.props.lang)
                                                                                    )
                                                                                }
                                                                            </Button>
                                                                    }

                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Collapse>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Col>
                    </Row>

                </Container>
                <DeleteModal
                    lang={this.props.lang}
                    zIndex={99999999999}
                    isOpen={this.state.deleteSectionItem}
                    toggle={() => this.setState({ deleteSectionItem: null })}
                    handler={() => {
                        let index = this.state.deleteSectionItem - 1;
                        let sections = this.state.sections;
                        let sectionId;
                        if (sections[index]) {
                            sectionId = sections[index].id;
                            sections.splice(index, 1);
                            this.setState({ sections, deleteSectionItem: null }, () => this.deleteSection(sectionId))
                        }

                    }}
                >
                    {'Are you sure you want to delete the test result?'.translate(this.props.lang)}
                </DeleteModal>

                {this.state.labPortalenAttachments ? <LabPortalenAttachmentsModal
                    key='labportalen-attachments-modal'
                    lang={this.props.lang}
                    isOpen={this.state.labPortalenAttachments ? true : false}
                    attachments={this.state.labPortalenAttachments}
                    onClose={() => this.setState({ labPortalenAttachments: null })}
                /> : null}

                {this.state.labPortalenRequisitionId && this.props.labPortalenData ? <Modal
                    isOpen={this.state.labPortalenRequisitionId && this.props.labPortalenData ? true : false}
                    toggle={() => this.setState({ labPortalenRequisitionId: null })}
                    fullscreen={true}
                    backdrop="static"
                    size='xl'
                >
                    <ModalBody>
                        <LabPortalenComponent
                            type='report'
                            dashboardUrl={this.props.labPortalenData?.dashboardUrl}
                            sessionCode={this.props.labPortalenData?.sessionCode}
                            patientSSN={this.props.labPortalenData?.patientSSN}
                            requisitionId={this.state.labPortalenRequisitionId}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => this.setState({ labPortalenRequisitionId: null })}
                        >
                            {'Close'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal> : null}

                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}

                        >
                            {this.state.error.translate(this.props.lang)}
                        </ErrorModal>

                        :
                        null
                }

            </div >
        );
    }
}

export default TestResults;